import { render, staticRenderFns } from "./ContentRelevanceRegister.vue?vue&type=template&id=77f5d124"
import script from "./ContentRelevanceRegister.vue?vue&type=script&lang=js"
export * from "./ContentRelevanceRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports